import {
  INMEAData,
  INMEALogbookItem,
  INMEALogbookSpec,
  INMEAProviderItem,
} from "src/interfaces/NMEA";

export const dataMapper = (rawData: any): INMEAData | null => {
  if (!rawData?.res) return null;
  const data = rawData.res;
  return {
    isMappingAvailable: data.isSetup,
    form: {
      data: data.data,
      list: {},
    },
    logbooks: data.logbooks.list.map(({ lbname, lbid }: INMEALogbookItem) => ({
      value: lbid,
      label: lbname,
    })),
    providers: data.providers.map(
      ({ providerid, name }: INMEAProviderItem) => ({
        value: providerid,
        label: name,
      }),
    ),
  };
};
export const specMapper = (data: any): INMEALogbookSpec | undefined => {
  if (!data) return { list: [], availableMappings: [] };
  const { list, availableMappings } = data;
  return { list: list || [], availableMappings: availableMappings || [] };
};
